import React from "react";
import dayjs from "dayjs";
import styled from "styled-components";
import { TimePicker as AntTimePicker } from "antd";

const StyledTimePicker = styled(AntTimePicker)`
  &.ant-picker{width:100%}
  .ant-picker-input input {
    color: ${({ inputColor }) => inputColor || "inherit"};
  }
  &.ant-picker.ant-picker-disabled{
   .ant-picker-input input{color: var(--input-text-disabled) !important;}
  }
`;

const TimePicker = ({
  value,
  onChange,
  format = "HH:mm",
  allowClear = true,
  use12Hours = false,
  size = "middle",
  placeholder = "Select a time",
  inputColor,
  disabled = false,
  onKeyDown,
  ...props
}) => {
  // Alt+T fills the field in with the current time. Ctrl+T is reserved by
  // Chrome/Firefox for "open new tab" and Ctrl+Shift+T for "reopen closed
  // tab" - neither can be intercepted by page JS, so Alt+T is used instead.
  // Wired directly onto this component (not a wrapper) since Form.Item
  // clones only its direct child to bind value/onChange.
  const handleKeyDown = (e) => {
    if (
      !disabled &&
      e.altKey &&
      !e.ctrlKey &&
      !e.metaKey &&
      !e.shiftKey &&
      e.key?.toLowerCase() === "t"
    ) {
      e.preventDefault();
      const now = dayjs();
      onChange?.(now, now.format(format));
    }
    onKeyDown?.(e);
  };

  // Same antd/rc-picker crash guard as CommonDatePicker — a non-dayjs
  // `value` makes antd's internal date.isValid() check blow up the page.
  const safeValue = dayjs.isDayjs(value) ? value : null;

  return (
    <StyledTimePicker
      value={safeValue}
      onChange={onChange}
      format={format}
      allowClear={allowClear}
      use12Hours={use12Hours}
      size={size}
      placeholder={placeholder}
      inputColor={inputColor}
      disabled={disabled}
      onKeyDown={handleKeyDown}
      {...props}
    />
  );
};

export default TimePicker;
